/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var shopifyHeaderSection = $('.shopify-section--header') //Shopify header section
var headerSection = $('#section-header') //HEADER
var headerLogo = $('.Header__FlexItem--logo') //LOGO
var headerRight = $(".header-right")          //HEADER RIGHT ICONS
var headerWrapper = $(".Header__Wrapper") //HEADER WRAPPER


  var scrollbarWidth = window.innerWidth - document.body.clientWidth 

 document.querySelector('.MegaMenu').style.width = `calc(100vw - ${scrollbarWidth}px)`
document.querySelector('.MegaMenu').style.left = `calc((33vw - ${scrollbarWidth + 10 }px) / -1 )`

$(window).scroll(function () {

  if (window.innerWidth > 1139) {
    if ($(this).scrollTop() > 1) {
      showFunction(shopifyHeaderSection, 'shopifyHeaderSection')
      showFunction(headerLogo, 'headerLogo')
      showFunction(headerSection, 'headerSection')
      showFunction(headerRight, 'headerRight')
    } else {
      hideFunction(shopifyHeaderSection, 'shopifyHeaderSection')
      hideFunction(headerLogo, 'headerLogo')
      hideFunction(headerSection, 'headerSection')
      hideFunction(headerRight, 'headerRight')
    }
  }
});



var hideFunction = function (element, className) {
  element.removeClass(className + 'Hide')
}
var showFunction = function (element, className) {
  element.addClass(className + 'Hide')
}


